/* ------------------------------------------------------------------
   Gift Box Builder — "Buy More, Save More" quantity-break widget.

   The app renders the widget into an open shadow root, so nothing in
   custom.css can reach it. This pushes an override sheet onto that
   shadow root (adopted sheets cascade last, so they win over the
   app's own rules and its inline custom properties) and inserts the
   tag icon the header design calls for.
   ------------------------------------------------------------------ */
(function () {
	var WRAPPER = '.gbbQbWidgetWrapper';

	// Phosphor Icons (regular) "tag", MIT licensed — https://phosphoricons.com
	var ICON =
		'<svg class="gbbQbHeaderIcon" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false">' +
		'<path d="M243.31,136,144,36.69A15.86,15.86,0,0,0,132.69,32H40a8,8,0,0,0-8,8v92.69A15.86,15.86,0,0,0,36.69,144L136,243.31a16,16,0,0,0,22.63,0l84.68-84.68a16,16,0,0,0,0-22.63Zm-96,96L48,132.69V48h84.69L232,147.31ZM96,84A12,12,0,1,1,84,72,12,12,0,0,1,96,84Z"/>' +
		'</svg>';

	var CSS = [
		/* Header reads as icon + label, with no rules either side of it. */
		'.gbbQbHeader .gbbQbHeaderLine { display: none !important; }',
		'.gbbQbHeader .gbbQbHeaderTitleRow { gap: 8px !important; }',
		'.gbbQbHeader .gbbQbHeaderIcon { flex: 0 0 auto; width: 20px; height: 20px; }',
		/* Tier labels ("Buy 1", "Buy 2"…) and their prices in Switzer bold. */
		'.gbbQbTierTitle { font-weight: 700 !important; }',
		'.gbbQbTierPriceDiscounted { font-weight: 700 !important; }',
		/* "Popular" / "Best deal" badges: softened square, not a full pill.
		   The app's own custom-CSS layer sets these !important at
		   `.gbbQbBundleLayout .gbbQbTierDiscountPill`, so the class is
		   repeated here purely to outrank it. */
		'.gbbQbBundleLayout .gbbQbTierDiscountPill.gbbQbTierDiscountPill {' +
		' font-size: 13px !important; border-radius: 6px !important; }'
	].join('\n');

	var sheet;

	function overrideSheet() {
		if (!sheet) {
			sheet = new CSSStyleSheet();
			sheet.replaceSync(CSS);
		}
		return sheet;
	}

	// Idempotent: the shadow observer below re-runs this after every re-render.
	function decorate(root) {
		var css = overrideSheet();
		if (root.adoptedStyleSheets.indexOf(css) === -1) {
			root.adoptedStyleSheets = root.adoptedStyleSheets.concat(css);
		}
		var row = root.querySelector('.gbbQbHeaderTitleRow');
		if (row && !row.querySelector('.gbbQbHeaderIcon')) {
			row.insertAdjacentHTML('afterbegin', ICON);
		}
	}

	var watched = new WeakSet();

	function scan() {
		var found = false;
		document.querySelectorAll(WRAPPER).forEach(function (el) {
			var root = el.shadowRoot;
			if (!root) return;
			found = true;
			decorate(root);
			if (watched.has(root)) return;
			watched.add(root);
			// The widget rebuilds its header on variant / tier changes.
			new MutationObserver(function () {
				decorate(root);
			}).observe(root, { childList: true, subtree: true });
		});
		return found;
	}

	if (!('adoptedStyleSheets' in Document.prototype)) return;

	// The app mounts asynchronously, and remounts when the variant changes.
	new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

	// Safety net for a mount that attaches its shadow root after insertion.
	var tries = 0;
	var poll = setInterval(function () {
		if (scan() || ++tries > 40) clearInterval(poll);
	}, 250);

	scan();
})();
